import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useModelCompareTranslation } from '../../../../../../constants/modelCompareData/translations/useModelCompareTranslation.mjs';
import { EmptyPropertyTitleGridItem, CenterPlaceholderGridItem, FootnotesWrap, Note } from '../../../CompareTable.styles.mjs';
"use strict";
const FootNotes = ({
  products
}) => {
  const {
    formatMessage
  } = useModelCompareTranslation();
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx(EmptyPropertyTitleGridItem, {
      stickX: true
    }), products.map((product, index) => {
      if (!product?.footnotes?.length) {
        return /* @__PURE__ */jsx(CenterPlaceholderGridItem, {}, `${product.id}-${index}`);
      }
      return /* @__PURE__ */jsx(FootnotesWrap, {
        children: product.footnotes.map((footnote, i) => /* @__PURE__ */jsx(Note, {
          children: formatMessage(footnote)
        }, i))
      }, `${product.id}-${index}`);
    })]
  });
};
export { FootNotes };
//# sourceMappingURL=FootNotes.mjs.map
